module.exports = __webpack_public_path__ + "static/assets/1900166faa9222d0d10c568a12c848a5.png";